import { render, staticRenderFns } from "./TopsSection.vue?vue&type=template&id=340a4a78&scoped=true&"
import script from "./TopsSection.vue?vue&type=script&lang=js&"
export * from "./TopsSection.vue?vue&type=script&lang=js&"
import style0 from "./TopsSection.vue?vue&type=style&index=0&id=340a4a78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340a4a78",
  null
  
)

export default component.exports